import React, {useMemo} from 'react'
import {SearchOrCreateDropdown} from '../../../webui/inputs/SearchOrCreateDropdown'
import {useAllBoxLocationsLite} from '../../box/gql/useAllBoxLocationsLite'

interface Props {
  onChange: (value: string) => void
  value?: string | undefined
}

const getUniqueCities = (locations: Array<{locality?: string | null}>): string[] => {
  return Array.from(new Set(locations.map((l) => l.locality?.trim()).filter((locality): locality is string => Boolean(locality)))).sort()
}

export const EditCity: React.FC<Props> = ({onChange, value}) => {
  const {data: allBoxes} = useAllBoxLocationsLite()

  const options = useMemo(() => {
    return getUniqueCities(allBoxes)
  }, [allBoxes])

  const handleChange = (newValue: string) => {
    onChange(newValue)
  }

  return (
    <div>
      <SearchOrCreateDropdown
        options={options}
        value={value}
        onChange={handleChange}
        placeholder="Select or type"
        label="City/Locality"
        // Style-only: match other selects (no behavior change)
        variant="standard"
      />
    </div>
  )
}
